<template>
  <div class="loading-dots">
    <div
      v-for="idx in [0,1,2]"
      class="loading-dots__dot"
      :class="`loading-dots__dot--${idx}`"
    ></div>
  </div>
</template>

<script>

export default{
}

</script>

<style lang="scss">

.loading-dots {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  height: rem(52);
  width: rem(96);
  box-sizing: border-box;
  padding: rem(20) !important;
  border-radius: rem(6);
  background-color: #ffffff;
  box-shadow: 0 0 rem(3) rgba(#000000, .2);

  &__dot {
    background: rgb(198, 204, 209);
    height: rem(12);
    width: rem(12);
    border-radius: 50%;
  }

  &__dot--0 {
    animation: dot-fade 1s $global-easing 0s infinite;
  }

  &__dot--1 {
    animation: dot-fade 1s $global-easing .25s infinite;
  }

  &__dot--2 {
    animation: dot-fade 1s $global-easing .5s infinite;
  }


  @keyframes dot-fade {
    0% {
      background-color: rgb(198, 204, 209);
    }
    40% {
      background-color: color(blues, turner);
    }
    80% {
      background-color: rgb(198, 204, 209);
    }
  }
}

</style>



// WEBPACK FOOTER //
// LoaderDots.vue?b8681ee2